export type Currency = "USD" | "EUR";

const currencyMapping: { [key in Currency]: string } = { EUR: "€", USD: "$" };

export function getCurrencySymbol(currency: Currency): string | undefined {
  return currencyMapping[currency];
}
